/**
 * One word passed between screens: the setup just changed.
 *
 * The chip in the top bar and the entry in the settings sidebar both show the percentage,
 * and both are mounted while the Setup page marks an item or the branding page saves a
 * logo. Neither is a parent of the other, so rather than lifting the state to the shell and
 * threading it through every area, the screens that change it say so and the screens that
 * show it ask the server again. The server is the authority on the number either way; this
 * only says when to ask.
 */

const target = new EventTarget();

const EVENT = 'taxi:setup-changed';

export function notifySetupChanged(): void {
  target.dispatchEvent(new Event(EVENT));
}

/** Runs the callback on every change until the returned function is called. */
export function onSetupChanged(callback: () => void): () => void {
  target.addEventListener(EVENT, callback);

  return () => target.removeEventListener(EVENT, callback);
}
